import logService from '../../../services/wss/logService3';
import responseHelper from '../../../services/ResponseHelper';
import documentService from '../../../services/DocumentService';
import CoreBase from '../../../services/engines/CoreBase';

export default class AttachmentFetcher extends CoreBase {
    // Class field — overrides CoreBase._name so logError shows correct source
    _name = 'AttachmentFetcher';

    /**
     * Fetches all documents linked to a journal entry.
     * BE returns a fresh signed URL per document — no TTL logic needed on FE.
     * @param {string} jid - Journal entry RK
     * @returns {object[]|null} array of documents, or null on failure
     */
    fetch = async (jid) => {
        try {
            // Guard — no jid means no documents to fetch
            if (!jid) return null;

            const resp = await documentService.getDocuments(jid);
            const code = responseHelper.check(resp, 'fetch', this._name);

            // Fetch failed — log via CoreBase, publishes to ErrorEngine
            if (code < 0) {
                //  this.logError('fetch', `getDocuments failed — code=${code}, jid=${jid}`);
                return null;
            }

            // KD8 envelope: resp.data.items holds the array
            return resp.data?.items ?? [];
        } catch (error) {
            logService.logError(`AttachmentFetcher.fetch: ${error.message}`);
            return null;
        }
    };
}
